/* import __COLOCATED_TEMPLATE__ from './multiselect.hbs'; */
import UserFieldBase from "./base";
import TEMPLATE from "./multiselect.hbs";
import { setComponentTemplate } from "@ember/component";
export default class UserFieldMultiselect extends UserFieldBase {}
setComponentTemplate(TEMPLATE, UserFieldMultiselect);